export class RegexRules {
  static PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  static EMAIL = /^[A-Za-z0-9_!#$%&'*+=?`{|}~^.-]+@[A-Za-z0-9.-]+$/;
  static INITIALS = /^[A-Za-z]{2,3}$/;
  static YEAR_OF_BIRTH = /^(19[0-9]{2}|[2-9][0-9]{3})$/;
  static GENDER = /^W|M$/;
}